import { getCurrentRulesEngineConfig } from '../config/utils';
export class BaseManager {
    constructor(params = {}) {
        this.updateState = () => {
            if (getCurrentRulesEngineConfig().store) {
                const store = getCurrentRulesEngineConfig().store;
                store === null || store === void 0 ? void 0 : store.subscribe(() => {
                    this.setState(store.getState());
                });
            }
        };
        this.setState = (newState) => {
            var _a;
            const state = newState || ((_a = getCurrentRulesEngineConfig().store) === null || _a === void 0 ? void 0 : _a.getState()) || null;
            //TODO testing this to see if it actually matters
            // if(!state){
            //     throw new Error('BaseManager: The base manager was not able to set the state')
            // }
            this.state = state;
        };
        this.getState = () => this.state || null;
        this.setDispatch = (newDispatch) => {
            var _a;
            const dispatch = newDispatch || ((_a = getCurrentRulesEngineConfig().store) === null || _a === void 0 ? void 0 : _a.dispatch) || null;
            //TODO testing this to see if it actually matters
            // if(!dispatch){
            //     throw new Error('BaseManager: The base manager was not able to set the dispatch')
            // }
            if (dispatch) {
                this.dispatch = dispatch;
            }
        };
        this.getDispatch = () => this.dispatch;
        this.setState(params.state);
        this.setDispatch(params.dispatch);
        this.updateState();
    }
}
